module.exports = __webpack_public_path__ + "static/media/ic_next.e38aa749.svg";